import { render, staticRenderFns } from "./backPay.vue?vue&type=template&id=5bd63169&"
import script from "./backPay.vue?vue&type=script&lang=js&"
export * from "./backPay.vue?vue&type=script&lang=js&"
import style0 from "./backPay.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports